export class SearchWorkItemsRequest {
    userid: string|number = 0
    countrycode: string = 'US';
    language: string = 'EN';
    LOB: string = 'OL';
    customerid: string|number = 0;
    search_type_value: string = '';
    search_type_code: string = 'Vehicle_VIN';
}
